// extracted by mini-css-extract-plugin
export default {"root":"inline_select-module___root___b2e8bfae","label":"inline_select-module___label___c7411b0c"};